/** Copyright (c) 2019 T. Rowe Price. All rights reserved. */

export const NO_SERVICE_LEVEL = null;
export const SERVICE_TYPE_CORE = 7;
export const SERVICE_TYPE_PFD = 8;
export const SERVICE_TYPE_HNW = 9;
export const SERVICE_TYPE_MIL = 10;
export const ENHANCED_PERSONAL_SERVICE_TITLE = 'Enhanced Service Benefits';
export const PERSONAL_SERVICE_TITLE = 'Personal Service Benefits';

/* morningstar status */
export const COMPLETE = 'COMPLETE'; // completed registration
export const LEGACY = 'LEGACY'; // has morning star premium or pending registration
export const NONE = 'NONE'; // has access but not registered
